module.exports = __webpack_public_path__ + "img/none_pic@2x.bc9ec6e8.png";